export const WORDS = [
  'toots',
  'clagg',
  'algie',
  'hoppy',
  'edgar',
  'quong',
  'fleet',
  'dobbs',
  'isolt',
  'hodag',
  'ulick',
  'dorea',
  'irene',
  'amata',
  'arcus',
  'krall',
  'chubb',
  'fumos',
  'tengu',
  'eddie',
  'cragg',
  'angus',
  'morag',
  'milly',
]
